import { fetchUserLastOrder } from 'lib/models/users';
import { useCallback, useEffect, useState } from 'react';

function useUserLastOrder(username: string, auto = true, refreshKey: number | null = null) {
	const [loading, setLoading] = useState<boolean>(auto);
	const [date, setDate] = useState<string | null>(null);

	const refetch = useCallback(async () => {
		setLoading(true);
		const response = await fetchUserLastOrder(username);

		setDate(response);
		setLoading(false);
	}, [username]);

	useEffect(() => {
		if (auto) {
			refetch();
		}
	}, [auto, refetch]);

	useEffect(() => {
		if (refreshKey !== null) {
			refetch();
		}
	}, [refreshKey, refetch]);

	return { loading, date, refetch, setLoading };
}

export default useUserLastOrder;
